// Gets a parameter identified by name from the url query string
    function getParameterByName(name) {
    	var url = window.location.href;
    	name = name.replace(/[\[\]]/g, "\\$&");
    	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    	if (!results) return null;
    	if (!results[2]) return '';
    	return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
    
    var discount = getParameterByName('discount');
    if (discount && discount != "") {
    	var xmlHttp = new XMLHttpRequest();
      	xmlHttp.open( "GET", "https://" + window.location.hostname + "/discount/" + discount, false ); // false for synchronous request
    	xmlHttp.send( null );
    }